import {MI} from "../init";
import ReelMotion from "./ReelMotion";
import SpinReel from "./SpinReel";
import ReelsEngine from "./ReelsEngine";

/**
 * @constructor
 * @returns {SpinReels}
 */
export default function SpinReels() {

    /**
     * @private
     * @type {Game}
     */
    this._game;

    /**
     * @private
     * @type {GameConfig}
     */
    this._gameConfig;

    /**
     * @private
     * @type {ServerConfig}
     */
    this._serverConfig;

    /** @type {SymbolsManager} */
    this.symbolsManager;

    /** @type Array<SpinReel> */
    this.reels = [];

    /**
     * @private
     * @type {ReelPrinter}
     */
    this._printer;

    /** @type {MadnesGraphics} */
    this.blackScreen;

    /** @type {number} */
    this.blackScreenAlpha = 0.7;

    /** @type {MadnesGroup} */
    this.symbolsGroup;
    /** @type {MadnesGroup} */
    this.spreadSymbolsGroup;
    /** @type {MadnesGroup} */
    this.animsSymbolsGroup;

    /** @type {MadnesGroup} */
    this.blackScreenGroupPre;
    /** @type {MadnesGroup} */
    this.blackScreenGroupPost;


    /** @type {ReelsEngine} */
    this._engine;
};

/**
 * @param {Game} game
 * @param {ReelPrinter} reelPrinter
 * @param {GameConfig} gameConfig
 * @param {ServerConfig} serverConfig
 * @param {SymbolsManager} symbolsManager
 * @returns {undefined}
 */
SpinReels.prototype.init = function(game, reelPrinter, gameConfig, serverConfig, symbolsManager) {
    this._game = game;
    this._printer = reelPrinter;
    this._gameConfig = gameConfig;
    this._gameConfig = gameConfig;
    this._serverConfig = serverConfig;
    this._symbolsManager = symbolsManager;
};

SpinReels.prototype.createReels = function() {

    this.symbolsGroup = MI.addGroup("group_symbols");

    this.blackScreenGroupPre = MI.addGroup("group_blscreen_pre");

    this.spreadSymbolsGroup = MI.addGroup("group_spread_symbols");

    this.blackScreenGroupPost = MI.addGroup("group_blscreen_post");

    this.animsSymbolsGroup = MI.addGroup("group_anims_symbols");

    this.createBlackScreen();

    var serverReels = this._serverConfig.getReels();
    var serverMatrix = this._serverConfig.getReelMatrix();
    var failMatrix = this._serverConfig.getFailResult();

    var serverPositions = this._serverConfig.getPositions();

    for(var i = 0; i < serverReels.length; i++) {

        var motion = new ReelMotion();
        var reel = new SpinReel();

        reel.init(this._game, i, this._gameConfig, this._symbolsManager, this._printer, motion);

        this.reels[i] = reel;
        this.reels[i].setAllMatrix(serverReels[i]);
        this.reels[i].setReelMatrix(serverMatrix[i]);
        this.reels[i].setFailMatrix(failMatrix[i]);
        this.reels[i].setSymbolPosition(serverPositions[i]);

        this.reels[i].create(this.symbolsGroup);

        motion.init(this._gameConfig, this._serverConfig, this.reels[i], this._printer);
    }

    this._engine = new ReelsEngine();
    this._engine.onLoop(function(delta) {

        for(var i = 0; i < 5; i++) {
            this.reels[i].motion.tick(delta);
        }

    }.bind(this));

    this.printReels();
};

SpinReels.prototype.destroyReelSymbols = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].destroyReelSymbols();
    }
};

SpinReels.prototype.visibleReelSymbols = function(bool) {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].visibleReelSymbols(bool);
    }
};

SpinReels.prototype.createAndPlayStandAnims = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].createAndPlayStandAnim();
    }
};

SpinReels.prototype.stopStandAnim = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].stopStandAnim(this.reels[i].reelSymbols);
    }
};

SpinReels.prototype.playStandAnim = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].playStandAnim();
    }
};

SpinReels.prototype.createShineAnim = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].createShineAnim();
    }
};

SpinReels.prototype.stopShineAnim = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].stopShineAnim();
    }
};

SpinReels.prototype.playShineAnim = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].playShineAnim();
    }
};

SpinReels.prototype.fadeOutStandAnim = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].fadeOutStandAnim();
    }
};

SpinReels.prototype.fadeInStandAnim = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].fadeInStandAnim();
    }
};

SpinReels.prototype.reinitReelsSymbols = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].initReelSymbols(this.symbolsGroup);
        this.reels[i].createReelSymbols();
        this.reels[i].initSymbols();
    }
};

SpinReels.prototype.startSpinReels = function () {
    this._engine.start();
};

SpinReels.prototype.stopSpinReels = function () {
    this._engine.stop();
};

SpinReels.prototype.createBlackScreen = function() {
    this.blackScreen = MI.addGraphics(0, 0, "black_screen");
    this.blackScreen.beginFill(0x000000);
    this.blackScreen.drawRectangle(50, 0, MI.getWi(), MI.getHe());
    this.blackScreen.setAlpha(0);
    this.blackScreen.setVisible(false);

    this.blackScreenGroupPre.add(this.blackScreen);
};

/**
 * @returns {Promise}
 */
SpinReels.prototype.fadeInBlackScreenPre = function() {
    return this._fadeInBlackScreen(this.blackScreenGroupPre);
};

/**
 * @returns {Promise}
 */
SpinReels.prototype.fadeInBlackScreenPost = function() {
    return this._fadeInBlackScreen(this.blackScreenGroupPost);
};


/**
 * @param {MadnesGroup} group
 * @returns {Promise}
 */
SpinReels.prototype._fadeInBlackScreen = function(group) {
    var _self = this;

    group && group.add(this.blackScreen);

    return new Promise(function(res) {

        if(_self.blackScreen.getAlpha() === _self.blackScreenAlpha) {
            res();
            return;
        }

        _self.blackScreen.setAlpha(0);
        _self.blackScreen.setVisible(true);

        MI.addTween().to(_self.blackScreen, { 'alpha': _self.blackScreenAlpha }, {
            'duration': 250,
            'callback': res
        });
    });
};

SpinReels.prototype.fadeOutBlackScreen = function() {
    return new Promise(function(res) {

        if(this.blackScreen.getAlpha() === 0) {
            res();
            return;
        }

        //this.blackScreen.setAlpha(1);
        MI.addTween().to(this.blackScreen, { 'alpha': 0 }, {
            'duration': 250,
            'callback': function() {
                this.blackScreen.setVisible(false);
                res();
            }.bind(this)
        });
    }.bind(this));
};

SpinReels.prototype.initSymbols = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].initSymbols();
    }

};

/**
 * @param {Array} reelMatrix
 * @returns {undefined}
 */
SpinReels.prototype.prepareResult = function(reelMatrix/*, searchScatter*/) {
    this.setResult(reelMatrix);
    this.makeReelSymbols(/*searchScatter*/);
    this.setMotionResult();
};

/**
 * @param {Array} reelMatrix
 * @param {boolean=} force
 * @returns {undefined}
 */
SpinReels.prototype.setResult = function(reelMatrix, force) {

    for(var i = 0; i < this.reels.length; i++) {
        if(!force && !this.reels[i].started) {
            console.warn("reel " + this.reels[i].id + " not spinning - cannot set result matrix");
            continue;
        }

        this.reels[i].setReelMatrix(reelMatrix[i]);
        this.reels[i].initReelSymbols(this.symbolsGroup);
    }
};

SpinReels.prototype.setMotionResult = function() {

    for(var i = 0; i < this.reels.length; i++) {
        if(!this.reels[i].started) {
            console.warn("reel " + this.reels[i].id + " not spinning - cannot set result");
            continue;
        }

        this.reels[i].motion.setResultSymbols(this.reels[i].reelSymbols);
    }
};

SpinReels.prototype.makeReelSymbols = function(/*searchingType*/) {
    for(var i = 0; i < this.reels.length; i++) {

        if(!this.reels[i].started) {
            console.warn("reel " + this.reels[i].id + " not spinning - cannot set blur symbol");
            continue;
        }

        /*if(searchingType === 1 || searchingType === 2 && !MI.controls.isForceStop()) {
            if(i === 2) {
                this.reels[i].createReelSymbols();
                continue;
            }
            if(i === 4 && searchingType === 2) {
                this.reels[i].createReelSymbols();
                continue;
            }
        }*/

        this.reels[i].createBlurSymbols(this.reels[i].reelSymbols);
    }
};

SpinReels.prototype.createBlurReelSymbols = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].createBlurSymbols(this.reels[i].reelSymbols);
    }
};

SpinReels.prototype.createReelSymbols = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.reels[i].createReelSymbols();
    }
};

SpinReels.prototype.printReels = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this._printer.print(this.reels[i]);
    }
};

/**
 * @public
 * @returns {Array<SpinReel>}
 */
SpinReels.prototype.getReels = function() {
    return this.reels;
};

/**
 * @param {number} id
 * @returns {SpinReel}
 */
SpinReels.prototype.getReel = function(id) {
    return this.reels[id];
};

SpinReels.prototype.getResSymbol = function(x, y) {
    return this.getReel(x).reelSymbols[y];
};

/**
 * @param {Array} positions
 * @returns {Array<AbstractSymbol>}
 */
SpinReels.prototype.getResSymbols = function(positions) {
    var symbols = [];

    for(var i = 0; i < positions.length; i++) {
        var x = positions[i][0];
        var y = positions[i][1];

        symbols.push(this.getResSymbol(x, y));
    }

    return symbols;
};

/**
 * @returns {Array<AbstractSymbol>}
 */
SpinReels.prototype.getAllReelSymbols = function() {
    var symbols = [];

    for(var i = 0; i < this.reels.length; i++) {

        for(var j = 0; j < this.reels[i].reelSymbols.length; j++) {
            symbols.push(this.reels[i].reelSymbols[j]);
        }
    }

    return symbols;
};

/**
 * @returns {Array<AbstractSymbol>}
 */
SpinReels.prototype.getAllSpreadedSymbols = function() {

    var symbols = this.getAllReelSymbols();
    var symbs = [];

    for(var i = 0; i < symbols.length; i++) {
        if(symbols[i].spreaded) {
            symbs.push(symbols[i]);
        }
    }

    return symbs;
};

/**
 * @param {number} id
 * @returns {AbstractSymbol|null}
 */
SpinReels.prototype.getSpreadedFromReel = function(id) {

    var symbols = this.getReel(id).reelSymbols;

    for(var i = 0; i < symbols.length; i++) {
        if(symbols[i].spreaded) {
            return symbols[i];
        }
    }

    return null;
};

/*SpinReels.prototype.getLastSpinningReel = function() {
	for(var i = this.reels.length -1; i >= 0; i--) {
		if(this.reels[i].motion.isMoving()) {
			return this.reels[i];
		}
	}
	return this.reels[this.reels.length -1];
};*/

/**
 *
 * @param {Array<AbstractSymbol>} spreadSymbols
 */
SpinReels.prototype.setSpreaded = function(spreadSymbols) {
    for(var i = 0; i < spreadSymbols.length; i++) {
        var reelX = spreadSymbols[i].reelPos['x'];
        this.getReel(reelX).spreaded = true;
    }
};

/**
 * @param {AbstractSymbol} symbol
 * @param {number=} reelX
 * @param {number=} reelY
 * @returns {undefined}
 */
SpinReels.prototype.addSymbol = function(symbol, reelX, reelY) {

    reelX = typeof reelX === 'undefined' ? symbol.getReelX() : reelX;
    reelY = typeof reelY === 'undefined' ? symbol.getReelY() : reelY;

    this.getReel(reelX).reelSymbols[reelY] = symbol;
};

/**
 * @param {AbstractSymbol} symbol
 * @returns {boolean}
 */
SpinReels.prototype.isInSpread = function(symbol) {
    var reelX = symbol.getReelX();
    return this.getReel(reelX).spreaded;

};

SpinReels.prototype.reinitSpreaded = function() {
    for(var i = 0; i < this.reels.length; i++) {
        this.getReel(i).spreaded = false;
    }
};